export default __webpack_public_path__ + "static/media/green-3.3e5e1711.png";